module.exports = __webpack_public_path__ + "img/256_Third of Brookfield_Pool_teracce_D2_cam1.8ff406ec.jpg";